import React, { useState, useEffect } from 'react';

const TeamTaskNotes = (props) => {
  const { task, teamTicketsRef } = props;
  const [notes, setNotes] = useState('');

  useEffect(() => {
    const fetchNotes = async () => {
      const taskDoc = await teamTicketsRef.doc(task).get();
      setNotes(taskDoc.data().notes);
    };
    fetchNotes();
  }, [task.id, teamTicketsRef]);

  const handleNotesChange = (event) => {
    setNotes(event.target.value);
  }

  const handleNotesBlur = async (event) => {
    await teamTicketsRef.doc(task).update({ notes: event.target.value });
  }

  return (
    <textarea className=" pl-1 notes h-40 text-gray-700" value={notes} onClick={(event) => event.stopPropagation()} onChange={handleNotesChange} onBlur={handleNotesBlur} />
  );
}

export default TeamTaskNotes;